import(/* webpackMode: "eager" */ "/Users/martina/Desktop/Project/cg-templates/cloudflare/next-js-cloudflare/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/Users/martina/Desktop/Project/cg-templates/cloudflare/next-js-cloudflare/components/sentry-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/Users/martina/Desktop/Project/cg-templates/cloudflare/next-js-cloudflare/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/Users/martina/Desktop/Project/cg-templates/cloudflare/next-js-cloudflare/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/Users/martina/Desktop/Project/cg-templates/cloudflare/next-js-cloudflare/components/ui/tooltip.tsx");
